import { ICellRendererParams } from 'ag-grid-community';
import { Component, OnInit, TemplateRef } from '@angular/core';

@Component({
    selector: 'cv-grid-template',
    templateUrl: './grid-template.component.html',
    styleUrls: ['./grid-template.component.scss']
})
export class GridTemplateComponent implements OnInit {

    public template: TemplateRef<any>;
    public context: any = {};

    constructor() { }

    ngOnInit(): void {
    }

    agInit(params: ICellRendererParams) {
        this.setTemplateAndParams(params);
    }

    setTemplateAndParams(params) {
        this.template = params['ngTemplate'];
        this.context = {
            rowInfo: {
                rowData: params.data,
                rowId: params.node.__objectId,
                columnName: params.colDef.headerName,
            },
        };
    }
}
